export enum EChatTypes {
    public = 'public',
    secret = 'secret',
    all = 'all',
}
